export default "__VITE_ASSET__C6vHI$I2__"